import AudioIcon from "../../assets/images/soundwave.png";
import AudioWhiteIcon from "../../assets/images/soundwaveWhite.svg";
import ButtonOn from "../../assets/images/button-on.png";
import DashboardIcon from "../../assets/images/dashboard.svg";
import DashboardSelectedIcon from "../../assets/images/dashboardSelected.png";
import DefaultAvatar from "../../assets/images/avatar.svg";
import DeleteIcon from "../../assets/images/delete-icon.png";
import EditIcon from "../../assets/images/edit-icon.png";
import Lock from "../../assets/images/lock.png";
import Logo from "../../assets/images/AppIcon.png";
import MusicIcon from "../../assets/images/music.png";
import PlusIcon from "../../assets/images/plusIcon.svg";
import PopularSongPlaceholder from "../../assets/images/popularSongPlaceholder.png";
import PromoCodeIcon from "../../assets/images/promocode.png";
import PromoCodeSelectedIcon from "../../assets/images/promocodeSelected.png";
import ReportIcon from "../../assets/images/report.png";
import ReportSelectedIcon from "../../assets/images/reportSelected.svg";
import SecurityIcon from "../../assets/images/security.png";
import SecuritySelectedIcon from "../../assets/images/securitySelected.svg";
import SongCardIcon from "../../assets/images/songCardIcon.svg";
import SongIcon from "../../assets/images/song.png";
import SongPlaceholder from "../../assets/images/songPlaceholder.png";
import SongSelectedIcon from "../../assets/images/songSelected.svg";
import Upload from "../../assets/images/upload.png";
import User from "../../assets/images/user.png";
import UserCardIcon from "../../assets/images/userCardIcon.svg";
import UsersIcon from "../../assets/images/users.png";
import ArtistsIcon from "../../assets/images/artists.png";
import UsersSelectedIcon from "../../assets/images/usersSelected.svg";
import ArtistsSelectedIcon from "../../assets/images/artistsSelected.svg";
import AdsSelectedIcon from "../../assets/images/adsSelected.svg";
import AdsIcon from "../../assets/images/ads.svg";
import VideoIcon from "../../assets/images/playlist.png";
import CheckIcon from "../../assets/images/check.png";
import RemoveIcon from "../../assets/images/remove.png";
import ReportsIcon from "../../assets/images/ico.png";
import ReportsSelectedIcon from "../../assets/images/reportsSelected.svg";
import InterviewIcon from "../../assets/images/interview.png";
import InterviewSelectedIcon from "../../assets/images/PodcastSelected.png";
import LiveIcon from "../../assets/images/LiveIcon.png"
import LiveOver from "../../assets/images/LiveOver.png"

const Images = {
  InterviewIcon,
  InterviewSelectedIcon,
  Logo,
  Lock,
  User,
  DashboardIcon,
  DashboardSelectedIcon,
  ReportSelectedIcon,
  ReportIcon,
  ReportsSelectedIcon,
  SecurityIcon,
  SecuritySelectedIcon,
  SongIcon,
  SongSelectedIcon,
  UsersIcon,
  ArtistsIcon,
  UsersSelectedIcon,
  ArtistsSelectedIcon,
  DefaultAvatar,
  MusicIcon,
  DeleteIcon,
  EditIcon,
  SongPlaceholder,
  ButtonOn,
  AudioIcon,
  AudioWhiteIcon,
  PopularSongPlaceholder,
  UserCardIcon,
  SongCardIcon,
  Upload,
  VideoIcon,
  PromoCodeIcon,
  PromoCodeSelectedIcon,
  PlusIcon,
  CheckIcon,
  RemoveIcon,
  AdsSelectedIcon,
  AdsIcon,
  ReportsIcon,
  LiveIcon,
  LiveOver
};

export default Images;
